import React from 'react';
import shortid from 'shortid';

import TeamMemberCard from 'components/teamMemberCard';
import HighlightedText from 'components/highlightedText';
import { Title } from 'components/typography';
import LearnMore from 'components/learnMore';

import { teamMembers } from './Team.constants';
import {
  team,
  teamMember,
  fullSquad,
  fullSquadTitle,
  squadLink,
} from './scss/Team.module.scss';

const Team = () => (
  <section className={team}>
    {teamMembers.slice(0, 4).map(member => (
      <TeamMemberCard key={shortid()} className={teamMember} {...member} />
    ))}
    <div className={fullSquad}>
      <div>
        <Title
          className={fullSquadTitle}
          size="xl"
          value={
            <span>
              One
              <HighlightedText value="Trybe" />
              <br />
              One
              <HighlightedText value="Vision" />
            </span>
          }
        />

        <LearnMore
          className={squadLink}
          prefix="MEET THE FULL"
          context="TRYBE'S SQUAD"
          theme="white"
          arrowType="default"
          href="/trybes-men"
        />
      </div>
    </div>
    {teamMembers.slice(4, 8).map(member => (
      <TeamMemberCard key={shortid()} className={teamMember} {...member} />
    ))}
  </section>
);

export default Team;
